import React from 'react';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';

import { injectIntl } from '../../util/reactIntl';
import { Form, FieldTextInput, Button, SecondaryButton } from '../../components';
import { required } from '../../util/validators';

import css from './SignupProviderForms.css';

const SignupProviderWhoAmIFrom = props => {
  return (
    <FinalForm
      {...props}
      render={formRenderProps => {
        const {
          rootClassName,
          className,
          handleSubmit,
          onPrev,
          form,
          intl,
          invalid,
        } = formRenderProps;

        const submitDisabled = invalid;

        const classes = classNames(rootClassName || css.root, className);

        const heading = intl.formatMessage({ id: 'SignupProviderForms.whoAmIHeading' });
        const whoAmIPlaceholder = intl.formatMessage({
          id: 'SignupProviderForms.whoAmIPlaceholder',
        });

        const point1 = intl.formatMessage({ id: 'SignupProviderForms.whoAmIPoint1' });
        const point2 = intl.formatMessage({ id: 'SignupProviderForms.whoAmIPoint2' });
        const point3 = intl.formatMessage({ id: 'SignupProviderForms.whoAmIPoint3' });

        const nextButtonText = intl.formatMessage({ id: 'SignupProviderForms.nextUpSkills' });
        const previousButtonText = intl.formatMessage({ id: 'SignupProviderForms.previousButton' });

        const whoAmIRequired = intl.formatMessage({ id: 'SignupProviderForms.whoAmIRequired' });

        return (
          <div className={classes}>
            <h2 className={css.mainHeading}>{heading}</h2>

            <Form className={css.form} onSubmit={values => handleSubmit(values, form)}>
              <div className={css.formFieldsContainer}>
                <FieldTextInput
                  type="text"
                  id="whoAmI"
                  name="whoAmI"
                  maxLength="50"
                  placeholder={whoAmIPlaceholder}
                  validate={required(whoAmIRequired)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      if (!invalid) {
                        // Submit the form
                        handleSubmit(form.getState().values, form);
                      }
                    }
                  }}
                />
                <ul className={css.pointerList}>
                  <li>{point1}</li>
                  <li>{point2}</li>
                  <li>{point3}</li>
                </ul>
              </div>
              <div className={css.submitContainer}>
                <SecondaryButton rootClassName={css.backButton} onClick={onPrev}>
                  {previousButtonText}
                </SecondaryButton>
                <Button rootClassName={css.nextButton} type="Submit" disabled={submitDisabled}>
                  {nextButtonText}
                </Button>
              </div>
            </Form>
          </div>
        );
      }}
    />
  );
};

export default injectIntl(SignupProviderWhoAmIFrom);
